module.exports = __webpack_public_path__ + "static/media/pexels-pavel-danilyuk-6461071.2bc6a958.jpg";